import { RootState } from 'store/rootSlices';

export const getBreadcrumbSelector = (state: RootState) => state.Breadcrumb;